// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import {
    formFieldDescriptionWrapperStyles,
    formFieldInputSelectDisabledStyles,
    formFieldInputSelectIconStyles,
    formFieldLabelStyles,
    formFieldVariantStyles,
} from "@store/Themes/common/mixins/formField";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/FormField ------------------------------------ */
/* ------------------------------------------------------------------------------------------ */

const formField: Styleguide["formField"] = {
    defaultProps: {
        border: "rounded",
        backgroundColor: "common.background",
        labelProps: {
            css: formFieldLabelStyles(),
        },
        errorProps: {
            color: "danger",
            size: "inherit",
            weight: "inherit",
            /* Store Custom Code - Start */
            css: css`
                display: flex;
            `,
            /* Store Custom Code - End */
        },
        hintProps: {
            color: "text", // Store Custom Code
            size: "inherit",
            weight: "normal",
            /* Store Custom Code - Start */
            css: css`
                display: flex;
                align-items: center;
            `,
            /* Store Custom Code - End */
        },
        cssOverrides: {
            inputSelect: css`
                ${formFieldVariantStyles()}
                ${formFieldInputSelectIconStyles("primary", "primary.dark")}
                ${formFieldInputSelectDisabledStyles("text.disabled", "common.disabled")}
                color: ${getColor("text.input")};
                /* Store Custom Code - Start */
                &.disabled[readonly] {
                    cursor: default;
                }
                /* Store Custom Code - End */
            `,
            descriptionWrapper: css`
                ${formFieldDescriptionWrapperStyles()}
                /* Store Custom Code - Start */
                font-weight: ${x => x.theme.design.typography.weight.base};
                /* Store Custom Code - End */
            `,
        },
    },
};

export default formField;
